if (!customElements.get('testimonials-marquee')) {
  class TestimonialsMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.testimonials-marquee__track');
      this.group = this.querySelector('.testimonials-marquee__group');
      this.groups = [...this.querySelectorAll('.testimonials-marquee__group')];

      if (!this.track || !this.group) return;

      this.updateDuration = this.updateDuration.bind(this);
      this.resizeObserver = new ResizeObserver(this.updateDuration);
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.group);
      requestAnimationFrame(this.updateDuration);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    updateDuration() {
      this.ensureCoverage();

      const groupWidth = this.group.getBoundingClientRect().width;
      const speed = Math.max(Number(this.dataset.speed) || 60, 1);

      if (groupWidth > 0) {
        this.track.style.setProperty('--testimonials-marquee-duration', `${groupWidth / speed}s`);
      }
    }

    ensureCoverage() {
      const minimumWidth = this.getBoundingClientRect().width * 1.1;

      this.groups.forEach((group) => {
        const template = group.querySelector('.testimonials-marquee__set[aria-hidden="true"]');
        if (!template || !template.querySelector('.testimonials-marquee__card')) return;

        let copiesAdded = 0;
        while (group.getBoundingClientRect().width < minimumWidth && copiesAdded < 30) {
          const copy = template.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          group.appendChild(copy);
          copiesAdded += 1;
        }
      });
    }
  }

  customElements.define('testimonials-marquee', TestimonialsMarquee);
}
